module.exports = __webpack_public_path__ + "static/media/visa.a1e1b4ae.svg";